import {
  ColoredCircle,
  EllipsedText,
  FlexColumn,
  FlexRow,
  LabeledData,
  UnorderedList,
} from '@gorila-shared-ui/components';
import { HeadingXSmall, LabelLarge, LabelMedium } from 'baseui/typography';
import { useState } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { JobActivityDetail } from '../../../types/jobs';
import { FormFieldResume } from '../../forms/FormFieldResume';
import { AsideLayout } from '../../layout/AsideLayout';

type Props = {
  jobId: string;
  activities: JobActivityDetail[];
};
export function JobActivitiesResume({ activities, jobId }: Readonly<Props>) {
  const { css, theme, classes } = useStyles();
  const [selectedActivity, setSelectedActivity] = useState<JobActivityDetail>();

  const LABEL_WIDTH = '80px';

  return (
    <FlexRow classNames={css({ height: '100%' })}>
      <AsideLayout
        canHide={selectedActivity !== undefined}
        asideSize={250}
        aside={
          <FlexColumn classNames={css({ overflow: 'auto' })}>
            <UnorderedList
              hideEndEnhancer
              items={activities.map((activity) => {
                return {
                  label: (
                    <LabelMedium>
                      <EllipsedText inline>{activity.name || '-'}</EllipsedText>
                    </LabelMedium>
                  ),
                  description: <EllipsedText inline>{activity.description ?? ''}</EllipsedText>,
                  onClick: () => {
                    setSelectedActivity(activity);
                  },
                };
              })}
            />
          </FlexColumn>
        }
      >
        {selectedActivity !== undefined && (
          <FlexColumn classNames={css({ overflow: 'hidden' })}>
            <FlexColumn gap={theme.sizing.scale200}>
              <HeadingXSmall margin={0}>{selectedActivity.name}</HeadingXSmall>
              <LabeledData
                label={'Descripción'}
                content={<EllipsedText maxLines={5}>{selectedActivity.description ?? '-'}</EllipsedText>}
                labelWidth={LABEL_WIDTH}
              />
              <LabeledData
                label={'Orden'}
                content={selectedActivity.order}
                labelWidth={LABEL_WIDTH}
              />
              <LabeledData
                label={'Estado'}
                content={
                  <FlexRow
                    classNames={css({ alignItems: 'center' })}
                    gap={theme.sizing.scale300}
                  >
                    <EllipsedText maxLines={5}>{selectedActivity.jobStatus?.name ?? '-'}</EllipsedText>
                    <ColoredCircle color={selectedActivity.jobStatus.color} />
                  </FlexRow>
                }
                labelWidth={LABEL_WIDTH}
              />
            </FlexColumn>
            {selectedActivity.forms.length !== 0 && (
              <>
                <LabelMedium className={classes.dataHeaderClass}>Formularios</LabelMedium>
                <FlexColumn classNames={css({ overflow: 'auto' })}>
                  {selectedActivity.forms.map((form) => {
                    return (
                      <FlexColumn key={form.name}>
                        <LabelLarge>{form.name}</LabelLarge>
                        {form.fields.map((field, index) => (
                          <FormFieldResume
                            jobId={jobId}
                            field={field}
                            key={index}
                          />
                        ))}
                      </FlexColumn>
                    );
                  })}
                </FlexColumn>
              </>
            )}
          </FlexColumn>
        )}
      </AsideLayout>
    </FlexRow>
  );
}
